import { getLanguages } from '../../../common/constants/lang/lang';

export const prepareLanguagesArray = selectedLanguage => {
	const initialArray = getLanguages();
	const arrWithoutSelected = initialArray.filter(e => e.label !== selectedLanguage.label);
	return [selectedLanguage, ...arrWithoutSelected.sort((a, b) => a.label.localeCompare(b.label))];
};
